import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import React from "react";
import styles from "./AppStackLayout.module.css";
import Aside from "./aside/Aside";
import Header from "./header/Header";
import info_icon from "assets/images/info_icon.svg";

function AppStackLayout({
  primaryText,
  secondaryText,
  openModal,
  handleClose,
  activeLink,
  children,
}) {
  return (
    <div className={styles.layout}>
      <Header activeLink={activeLink} />
      <div className={styles.body}>
        <div className={styles.drawer}>
          <Aside activeTab={activeLink} />
        </div>
        <div className={styles.tab}>{children}</div>
      </div>
      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              handleClose();
            }}
            icon={info_icon}
            primaryText={primaryText}
            secondaryText={secondaryText}
          />
        }
      />

     
    </div>
  );
}

export default AppStackLayout;
